import * as React from 'react';
import Button from '@mui/material/Button';
// import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Footer from '../../components/footer';
import Header from '../../components/header';
import { InputAdornment, IconButton, Stack } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Download from '../../components/download';
//import { useToasts } from 'react-toast-notifications';
import LeftSection from '../../components/leftsection';
import appTheme from '../../components/apptheme';
import { useFormik } from 'formik';
import validateSignInForm from './ValidateSignInForm';
import { useDispatch, useSelector } from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import { ReactComponent as HeartLogo } from '../../images/Logo-Rebekah.svg';
import * as signupActions from '../../actions/signupActions';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
//import * as caseActions from '../../actions/caseActions';
import * as Constants from '../../config/constants';

export default function SignIn() {
  // console.log('SignIn: - SignIn page loading...');
  const st = useSelector((state) => state.rootReducer);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  //const { addToast } = useToasts();
  const { enqueueSnackbar } = useSnackbar();
  const [formSubmitState, setFormSubmitState] = useState(false);
  const [loading, setLoading] = React.useState(false);
  // let timer;

  React.useEffect(() => {
    // clearTimeout(timer);
    console.log('formSubmitState:', formSubmitState);
    console.log('st.isLoginLoading:', st.isLoginLoading);
    console.log('st.isGetCaseLoading:', st.isGetCaseLoading);
    console.log('st.loginerror', st.loginerror);
    console.log('st.getCasesError', st.getCasesError);
    if (
      formSubmitState &&
      !st.isLoginLoading &&
      !st.isGetCaseLoading &&
      st.isLoggedIn &&
      st.loginerror === '' &&
      st.getCasesError === ''
    ) {
      // success on login API call
      setLoading(false);
      // banner message
      enqueueSnackbar(Constants.LOGIN_SUCCESS, {
        variant: 'success'
      });
      //dispatch(caseActions.setShowWelcomeBack(true));
      navigate('/sop2web/home');
      setFormSubmitState(false);
      dispatch(loginActions.clearError());
    } else if (st.loginerror !== '' || st.getCasesError !== '') {
      // error on login API call
      //dispatch(caseActions.setShowWelcomeBack(false));
      setLoading(false);
      setFormSubmitState(false);
    }
  }, [formSubmitState, st.isLoginLoading, st.isGetCaseLoading, st.loginerror, st.getCasesError]);

  const submitLogin = (values) => {
    // dispatch(loginActions.clearError());
    // if (!loading) {
    // reset count
    // console.log(values);
    dispatch(loginActions.requestLogin(values.email, values.password));
    setLoading(true);
    setFormSubmitState(true);
    // setCount(0);
    /*timer = setTimeout(() => {
        setFormSubmitState(true);
        setLoading(false);
      }, 3000);*/
    // }
  };
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const formik = useFormik({
    initialValues: {
      email: st.email,
      password: st.password,
      error: ''
    },
    validationSchema: validateSignInForm,
    onSubmit: (values) => {
      // alert('Submit login API\n' + JSON.stringify(values, null, 2));
      // dispatch(caseActions.setDataUpdated(false));
      submitLogin(values);
    }
  });

  return (
    <ThemeProvider theme={appTheme}>
      <Header />
      <Box>
        <Grid container component="main" sx={styles.containerStyle}>
          <Grid item xs={12} sm={12} md={6} sx={styles.photoSectionStyle}>
            <LeftSection />
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={styles.rightSectionGridStyle}>
            <Box sx={styles.titleBoxStyle}>
              <Stack spacing={2} sx={styles.titleStackStyle}>
                <Typography variant="h4">Welcome back!</Typography>
                <Typography variant="h6">Login to get started.</Typography>
              </Stack>
              <Box sx={styles.formCardContainerStyle}>
                <Stack direction="row" spacing="8px" sx={styles.formCardTitleStyle}>
                  <HeartLogo />
                  <Typography component="h1" variant="h5">
                    HeartOpinion
                  </Typography>
                </Stack>
                <Box
                  component="form"
                  noValidate
                  // onSubmit={formik.handleSubmit}
                  sx={styles.formCardInputStyle}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={formik.values.email}
                    onChange={(e) => {
                      formik.handleChange(e);
                      // dispatch(caseActions.setDataUpdated(true));
                    }}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    autoComplete="current-password"
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    value={formik.values.password}
                    onChange={(e) => {
                      formik.handleChange(e);
                      // dispatch(caseActions.setDataUpdated(true));
                    }}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                  <Box>
                    <Typography style={styles.errorText}>
                      {st.loginerror + st.getCasesError}
                    </Typography>
                  </Box>
                  <Box sx={{ m: 1, position: 'relative' }}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      onClick={formik.handleSubmit}
                      sx={styles.formCardButtonStyle}>
                      Log In
                    </Button>
                    {loading && (
                      <CircularProgress
                        size={24}
                        sx={{
                          color: green[500],
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          marginTop: '-12px',
                          marginLeft: '-12px'
                        }}
                      />
                    )}
                  </Box>
                  <Box sx={styles.formCardOneNavigateStyle}>
                    <Button
                      onClick={() => {
                        if (st.loginerror !== '' || st.getCasesError !== '')
                          dispatch(loginActions.clearError());
                        navigate('/sop2web/resetpassword');
                      }}
                      sx={styles.linkTextStyle}
                      // variant="body1"
                      color="inherit">
                      Forgot password?
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Box sx={styles.formCardContainerStyle}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    mt: 3,
                    mb: 0
                  }}>
                  <Typography variant="body1">{'New to HeartOpinion?'}&nbsp;</Typography>
                  <Button
                    onClick={() => {
                      if (st.loginerror !== '' || st.getCasesError !== '')
                        dispatch(loginActions.clearError());
                      navigate('/sop2web/signup');
                    }}
                    sx={styles.linkTextStyle}
                    // variant="body1"
                    color="inherit">
                    Sign up here
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    mb: 3
                  }}>
                  <Typography variant="body1">{'Signed up but not confirmed?'}&nbsp;</Typography>
                  <Button
                    onClick={() => {
                      // resend code
                      console.info('Resend code.');
                      if (st.loginerror !== '' || st.getCasesError !== '')
                        dispatch(loginActions.clearError());
                      if (formik.values.email !== '') {
                        dispatch(signupActions.resendCodeSignUp(formik.values.email));
                      } else {
                        dispatch(signupActions.signupFailed('Email can not be empty.'));
                      }
                      navigate('/sop2web/confirmcode');
                    }}
                    sx={styles.linkTextStyle}
                    // variant="body1"
                    color="inherit">
                    Confirm a code
                  </Button>
                </Box>
              </Box>
              <Box sx={styles.downloadContainerStyle}>
                <Download />
              </Box>
            </Box>
          </Grid>
          <Footer />
        </Grid>
      </Box>
    </ThemeProvider>
  );
}
const styles = {
  containerStyle: {
    // height: '86vh',
    display: 'flex',
    // alignItems: 'center',
    border: 0,
    justifyContent: 'center',
    backgroundColor: '#EDF3FC'
  },
  photoSectionStyle: {
    backgroundColor: '#EDF3FC',
    display: 'flex',
    alignItems: 'center',
    border: 0
    // justifyContent: 'flex-start'
  },
  rightSectionGridStyle: {
    // height: '86vh',
    backgroundColor: '#EDF3FC',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 0,
    // justifyContent: 'center',
    minWidth: 500
  },
  titleBoxStyle: {
    alignItems: 'flex-start',
    my: 8
  },
  titleStackStyle: {
    alignItems: 'flex-start'
  },
  formCardContainerStyle: {
    my: 4,
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 500,
    background: '#FFFF'
  },
  formCardTitleStyle: {
    mt: 2,
    mx: 2,
    alignItems: 'center',
    justifyContent: 'center'
  },
  formCardInputStyle: {
    mt: 2,
    width: 380
  },
  formCardButtonStyle: {
    mt: 1,
    mb: 2,
    flex: 1
  },
  formCardOneNavigateStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 4
  },
  linkTextStyle: {
    color: '#003087',
    fontSize: 20
    // textDecorationLine: 'underline'
  },
  downloadContainerStyle: {
    my: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  errorText: {
    color: '#F6323E',
    fontWeight: 'normal',
    fontSize: 16,
    //marginBottom: 10,
    marginTop: 6,
    marginLeft: 10,
    textAlign: 'left'
  }
};
